import type { LiteralValues } from '@/utils/typing/literal-values.type';

export interface ReferenceListItem {
    code: string;
    label: string;
    iconUrl?: string;
    rank?: number;
}

export const ReferenceListName = {
    ACTION_TYPE: 'actionType',
    ACTION_STATUS: 'actionStatus',
    ALERT: 'alert',
    ALERT_USEFULNESS: 'alertUsefulness',
    ANALYTICS: 'analytics',
    BRANDING: 'branding',
    BUILDING: 'building',
    BUILDING_INDICATOR_WARNING_MESSAGE: 'buildingIndicatorWarningMessage',
    BUSINESS_INTELLIGENCE_MEMBER: 'businessIntelligenceMember',
    CATEGORY: 'category',
    CHART_TITLE: 'chartTitle',
    CATEGORY_ATTRIBUTE: 'categoryAttribute',
    COMPARISON: 'comparison',
    COUNTER_TYPE: 'counterType',
    CURRENCY: 'currency',
    DASHBOARD_NAME: 'dashboardName', // Tailored dashboard and Legacy dashboard
    DATASOURCE: 'datasource',
    DAY_SET: 'daySet',
    DELIVERY_POINT_SOURCE: 'deliveryPointSource',
    FEATURE_TYPE: 'featureType',
    IMPORT_TYPE: 'importType',
    INDICATOR: 'indicator',
    INVOICE_CONSISTENCY: 'invoiceConsistency',
    INVOICE_ERROR: 'invoiceError',
    INVOICE_ERROR_RESOLUTION_LABEL: 'invoiceErrorResolutionLabel',
    INVOICE_ERROR_STATUS: 'invoiceErrorStatus',
    LANG: 'lang',
    MESSAGE_TRANSLATION: 'messageTranslation',
    OCCUPANCY_TYPE: 'occupancyType',
    PHYSICAL_INDICATOR: 'physicalIndicator',
    POINT_SEN_DATA_SOURCE: 'pointSenDataSource',
    PROFILE: 'profile',
    REMARK: 'remark',
    REPORT_TYPE: 'reportType',
    RESOURCE_TYPE: 'resourceType',
    ROLE_DESCRIPTION: 'roleDescription',
    ROLE_NAME: 'roleName',
    SENSOR: 'sensor',
    TASK_TYPE: 'taskType',
    UNIT: 'unit',
    UNIT_GROUP_CHART_TITLE: 'unitGroupChartTitle',
    UNIT_LABEL: 'unitLabel',
    UNIVERSE: 'universe',
    USAGE: 'usage',
    USAGE_CODE: 'usageCode',
    WIDGET_REPRESENTATION_TYPE: 'widgetRepresentationType',
    WIDGET_TEMPLATE: 'widgetTemplate',
    DISTRIBUTOR_METADATA: 'distributorMetadata',
    EFA_CONSUMPTION_TYPE: 'efaConsumptionType',
    OPERAT_ENERGY_CODE: 'operatEnergyCode'
};
export type ReferenceListName = LiteralValues<typeof ReferenceListName>;

export const allReferenceListsNames: ReferenceListName[] = Object.values(ReferenceListName);
